<template>
  <div>
    <v-select
      :model-value="modelValue"
      :items="purposes"
      item-title="name"
      item-value="id"
      :label="$t('ncrm.integrations.companyEmail.send.fields.purpose')"
      :loading="loading"
      :disabled="disabled || loading"
      :error-messages="error ? [error] : []"
      :menu-props="menuProps"
      v-model:menu="menuOpen"
      @keyup.tab="openFromKeyboard"
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <div v-if="!loading && !error && !purposes.length" class="text-caption text-warning mt-n3 mb-3">
      {{ $t("ncrm.integrations.companyEmail.send.noActivePurposes") }}
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "NcrmEmailPurposeSelect",
  emits: ["update:modelValue"],
  props: {
    modelValue: { type: [Number, String], default: null }, disabled: { type: Boolean, default: false },
    // The selector is reused inside the SMTP drawer (z-index 3201). Vuetify's
    // default menu overlay is lower and would render the options behind it.
    menuProps: { type: Object, default: () => ({ maxHeight: 320, zIndex: 3210 }) },
  },
  data: () => ({ purposes: [], loading: false, error: "", menuOpen: false }),
  mounted() { this.loadPurposes(); },
  methods: {
    // Tab into the field opens the list (keyup lands on the newly focused field), so keyboard users
    // pick a purpose instead of facing an empty field; mouse clicks keep Vuetify's own toggle.
    openFromKeyboard() {
      if (!this.disabled && !this.loading && this.purposes.length) this.menuOpen = true;
    },
    async loadPurposes() {
      this.loading = true;
      this.error = "";
      try {
        const { data } = await axios.get("/company-email/send/purposes");
        this.purposes = data?.items || [];
      } catch (error) {
        this.purposes = [];
        this.error = error?.response?.data?.error
          || this.$t("ncrm.integrations.companyEmail.send.errors.loadPurposes");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
